import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ChevronRightIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.27 12.734a.9.9 0 0 1 0-1.286L8.772 8 5.27 4.552a.9.9 0 0 1 0-1.286.933.933 0 0 1 1.306 0l4.154 4.091a.9.9 0 0 1 0 1.286l-4.154 4.09a.933.933 0 0 1-1.306 0Z", fill: "currentColor" })));
});
ChevronRightIcon.displayName = 'ChevronRightIcon';
export default ChevronRightIcon;
